import { computed, Injectable, signal } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class AppVersionService
{
    readonly currentVersion = environment.version;
    readonly latestVersion = signal<string | null>(null);
    readonly upgradeRequired = computed(() =>
    {
        const latestVersion = this.latestVersion();

        return latestVersion !== null && this.compareVersions(latestVersion, this.currentVersion) > 0;
    });

    setLatestVersion(version: string | null)
    {
        const latestVersion = version?.trim() || null;

        if (latestVersion === null || latestVersion === this.latestVersion())
        {
            return;
        }

        this.latestVersion.set(latestVersion);
    }

    private compareVersions(a: string, b: string): number
    {
        const aParts = this.parseVersion(a);
        const bParts = this.parseVersion(b);
        const partCount = Math.max(aParts.length, bParts.length);

        for (let i = 0; i < partCount; i++)
        {
            const aPart = aParts[i] ?? 0;
            const bPart = bParts[i] ?? 0;

            if (aPart !== bPart)
            {
                return aPart > bPart ? 1 : -1;
            }
        }

        return 0;
    }

    private parseVersion(version: string): number[]
    {
        return version.split('.').map((part) => Number.parseInt(part, 10) || 0);
    }
}
